import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "../lib/cn.js";
const badgeVariants = cva("inline-flex min-h-6 w-fit items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold leading-none", {
    variants: {
        tone: {
            neutral: "border-border bg-muted text-muted-foreground",
            info: "border-primary/15 bg-primary-soft text-primary",
            success: "border-success/15 bg-success-soft text-success",
            warning: "border-warning/15 bg-warning-soft text-warning",
            danger: "border-destructive/15 bg-destructive-soft text-destructive",
        },
        variant: {
            default: "border-transparent bg-primary text-primary-foreground",
            secondary: "border-transparent bg-secondary text-secondary-foreground",
            destructive: "border-transparent bg-destructive-soft text-destructive",
            outline: "border-border bg-transparent text-foreground",
            ghost: "border-transparent bg-transparent text-muted-foreground",
            link: "border-transparent bg-transparent text-primary underline-offset-4 hover:underline",
        },
    },
    defaultVariants: { tone: "neutral" },
});
export function Badge({ className, tone, variant, ...props }) {
    return (_jsx("span", { "data-slot": "badge", className: cn(badgeVariants({ tone: tone ?? (variant ? null : "neutral"), variant }), className), ...props }));
}
export { badgeVariants };
//# sourceMappingURL=badge.js.map